import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Rx'
import { get, accept, reject } from 'store/services/user'
import { alertSuccess, alertErrorDefault } from 'store/ducks/alert'
import { intl } from 'i18n'

// Actions
export const GET_USER_REQUEST = 'admin/userValidate/GET_USER_REQUEST'
export const GET_USER_SUCCESS = 'admin/userValidate/GET_USER_SUCCESS'
export const GET_USER_FAILURE = 'admin/userValidate/GET_USER_FAILURE'

export const ACCEPT_USER_REQUEST = 'admin/userValidate/ACCEPT_USER_REQUEST'
export const ACCEPT_USER_SUCCESS = 'admin/userValidate/ACCEPT_USER_SUCCESS'
export const ACCEPT_USER_FAILURE = 'admin/userValidate/ACCEPT_USER_FAILURE'

export const REJECT_USER_REQUEST = 'admin/userValidate/REJECT_USER_REQUEST'
export const REJECT_USER_SUCCESS = 'admin/userValidate/REJECT_USER_SUCCESS'
export const REJECT_USER_FAILURE = 'admin/userValidate/REJECT_USER_FAILURE'

// Reducer
const INITIAL = {
  user: null,
  loading: false,
  accepted: null,
  rejected: null,
  errors: [],
}

export function reducer(state = INITIAL, action = {}) {
  switch (action.type) {
    case GET_USER_REQUEST:
      return {
        ...INITIAL,
        loading: true,
      }
    case GET_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.user,
      }
    case GET_USER_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case ACCEPT_USER_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case ACCEPT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        accepted: true,
      }
    case ACCEPT_USER_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      }
    case REJECT_USER_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case REJECT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        rejected: true,
      }
    case REJECT_USER_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      }
    default:
      return state
  }
}

// Actions Creators
export const getUserRequest = (id) => ({
  type: GET_USER_REQUEST,
  id,
})

export const getUserSuccess = (user) => ({
  type: GET_USER_SUCCESS,
  user,
})

export const getUserFailure = () => ({
  type: GET_USER_FAILURE,
})

export const acceptUserRequest = (id, message) => ({
  type: ACCEPT_USER_REQUEST,
  id,
  message,
})

export const acceptUserSuccess = () => ({
  type: ACCEPT_USER_SUCCESS,
})

export const acceptUserFailure = (errors) => ({
  type: ACCEPT_USER_FAILURE,
  errors,
})

export const rejectUserRequest = (id, message) => ({
  type: REJECT_USER_REQUEST,
  id,
  message,
})

export const rejectUserSuccess = () => ({
  type: REJECT_USER_SUCCESS,
})

export const rejectUserFailure = (errors) => ({
  type: REJECT_USER_FAILURE,
  errors,
})

// Epics
export const epic = combineEpics(
  getUserRequestEpic,
  acceptUserRequestEpic,
  rejectUserRequestEpic,
  sendAlertOnfailureEpic,
  sendAlertOnAcceptSuccessEpic,
  sendAlertOnRejectSuccessEpic,
)

export function getUserRequestEpic(action$) {
  return action$.ofType(GET_USER_REQUEST).mergeMap((action) =>
    Observable.ajax(get(action.id))
      .map((res) => getUserSuccess(res.response))
      .catch((res) => Observable.of(getUserFailure())),
  )
}

export function acceptUserRequestEpic(action$) {
  return action$.ofType(ACCEPT_USER_REQUEST).mergeMap((action) =>
    Observable.ajax(accept(action.id))
      .map((res) => acceptUserSuccess(res))
      .catch((res) => Observable.of(acceptUserFailure(res.response.errors))),
  )
}

export function rejectUserRequestEpic(action$) {
  return action$.ofType(REJECT_USER_REQUEST).mergeMap((action) =>
    Observable.ajax(reject(action.id, action.message))
      .map((res) => rejectUserSuccess(res))
      .catch((res) => Observable.of(rejectUserFailure(res.response.errors))),
  )
}

export function sendAlertOnAcceptSuccessEpic(action$) {
  return action$
    .ofType(ACCEPT_USER_SUCCESS)
    .mapTo(alertSuccess(intl.formatMessage({ id: 'ducks.userValidate.accept.success' })))
}

export function sendAlertOnRejectSuccessEpic(action$) {
  return action$
    .ofType(REJECT_USER_SUCCESS)
    .mapTo(alertSuccess(intl.formatMessage({ id: 'ducks.userValidate.reject.success' })))
}

export function sendAlertOnfailureEpic(action$) {
  return action$.ofType(GET_USER_FAILURE, REJECT_USER_FAILURE, ACCEPT_USER_FAILURE).mapTo(alertErrorDefault())
}
